import Label from '../../../components/label/Label';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '../../../components/ui/Card';
import { useGetRTKQSingleListingQuery } from '../../../redux/rtkQuery/apiSlice';
import { fCurrency } from '../../../utils/formatNumber';
import { FDateFormat, fDate } from '../../../utils/formatTime';
import { fBedrooms } from '../../../utils/owner-portal/fBedrooms';
import { LoadingDetails } from '../reservation/LoadingDetails';

interface ListingDetailsCardI {
  listingId: string;
  handleOpenSupportPopover: (event: React.MouseEvent<HTMLElement>) => void;
}

export default function ListingDetailsCard(props: ListingDetailsCardI) {
  const { handleOpenSupportPopover, listingId } = props;
  const {
    data: listing,
    isFetching,
    isSuccess
  } = useGetRTKQSingleListingQuery({ listingId: listingId });

  return (
    <>
      {isFetching && <LoadingDetails numRows={3} />}
      {isSuccess && (
        <Card>
          <CardHeader className="p-4 pb-4 sm:p-6 sm:pb-6">
            <div>
              <div className="flex flex-row items-start justify-between gap-2">
                <CardTitle className="text-xl">{listing?.name_detailed}</CardTitle>
                <Label
                  color={listing?.stage_mapped === 'active' ? 'primary' : 'default'}
                  className="shrink-0 capitalize"
                >
                  {listing?.stage_mapped}
                </Label>
              </div>
              {listing && (
                <CardDescription className="text-sm">
                  {listing.unit_view} · {fBedrooms(listing.bedrooms)} · {listing.bathrooms} BA
                </CardDescription>
              )}
            </div>
          </CardHeader>
          <CardContent className="p-4 pt-0 sm:p-6 sm:pt-0">
            <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 md:grid-cols-4">
              <div className="space-y-1">
                <dt className="text-xs font-medium text-muted-foreground">Lessor</dt>
                <dd className="text-sm font-medium text-foreground">{listing?.lessor_name}</dd>
              </div>
              <div className="space-y-1">
                <dt className="text-xs font-medium text-muted-foreground">Support</dt>
                <dd>
                  <button
                    type="button"
                    onClick={handleOpenSupportPopover}
                    className="text-left text-sm font-medium text-primary dark:text-secondary underline-offset-4 hover:underline"
                  >
                    {listing?.owner_name}
                  </button>
                </dd>
              </div>
              {listing?.effective_date_ISO && (
                <div className="space-y-1">
                  <dt className="text-xs font-medium text-muted-foreground">Effective Date</dt>
                  <dd className="text-sm font-medium text-foreground">
                    {fDate(
                      listing.effective_date_ISO,
                      FDateFormat.localized_us_long_month_day_year
                    )}
                  </dd>
                </div>
              )}
              {listing?.minimum_rate != null && (
                <div className="space-y-1">
                  <dt className="text-xs font-medium text-muted-foreground">Minimum Rate</dt>
                  <dd className="text-sm font-medium text-foreground tabular-nums">
                    {fCurrency(listing.minimum_rate)}
                  </dd>
                </div>
              )}
            </dl>
          </CardContent>
        </Card>
      )}
    </>
  );
}
